import { Locale } from 'modules/i18n';

export const addToProjectButtonTranslation = {
  [Locale.en]: {
    addToProject: 'Add to project',
  },
};
